'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _prep = require('./internal/prep');

var _prep2 = _interopRequireDefault(_prep);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

exports.default = (0, _prep2.default)({
    name: 'insert',
    immutable: 'insert',
    array: function array(index, childValue) {
        return function (value) {
            var clone = [].concat(_toConsumableArray(value));
            clone.splice(index, 0, childValue);
            return clone;
        };
    }
});


//////////////////
// WEBPACK FOOTER
// ./~/unmutable/lib/insert.js
// module id = 389
// module chunks = 35783957827783